import { render, staticRenderFns } from "./CardUser.vue?vue&type=template&id=6a4bc244&scoped=true&"
import script from "./CardUser.vue?vue&type=script&lang=js&"
export * from "./CardUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4bc244",
  null
  
)

export default component.exports